import React, { Component } from 'react';
import './App.css';
import MainContainer from './components/MainContainer/MainContainer';

class App extends Component {
   render() {
    return (
      <div>
        <MainContainer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js